<div class="d-flex flex-column mt-4">
    <div class="alert alert-light d-flex justify-content-center align-items-center">
        <h3 class="mb-0">{{ titleText }}</h3>
        @if (categoryId) {
            <button class="ms-4 btn btn-blank"
                    data-tour="clear-category-summary"
                    adaptTooltip="Return to organisation highlights"
                    adaptButtonIcon="fal fa-arrow-turn-down-left"
                    (click)="clearCategoryId()"></button>
        }
    </div>

    <div class="row gx-2">
        @if (gradeSummaryText) {
            <div class="d-flex align-items-stretch col-lg"
                 data-tour="category-summary-average">
                <div class="d-flex flex-column justify-content-baseline alert alert-secondary w-100">
                    <adapt-display-category-percentage class="d-flex justify-content-center"
                                                       text="Average"
                                                       [percentage]="percentageScore"
                                                       [surveyType]="survey?.surveyType"></adapt-display-category-percentage>
                    <div class="mt-3">{{ gradeSummaryText }}</div>
                </div>
            </div>
        }
        <div class="d-flex align-items-stretch col-lg"
             data-tour="category-summary-doing-well">
            <div class="d-flex flex-column justify-content-baseline alert alert-success w-100">
                <h5>What your team are doing well at</h5>
                @for (top of topScoreQuestions; track top) {
                    <div class="w-100 alert alert-success d-flex good-style">
                        <span class="me-2">{{ top.questionText }}</span>
                        <span class="ms-auto">{{ top.score }}%</span>
                    </div>
                }
                @if (topScoreQuestions.length === 0) {
                    <span>You have a lot of work to do ☹</span>
                }
            </div>
        </div>
        <div class="d-flex align-items-stretch col-lg"
             data-tour="category-summary-need-improvement">
            <div class="d-flex flex-column justify-content-baseline alert alert-danger w-100">
                <h5>What your team can improve on</h5>
                @for (top of worstScoreQuestions; track top) {
                    <div class="w-100 alert alert-danger d-flex bad-style">
                        <span class="me-2">{{ top.questionText }}</span>
                        <span class="ms-auto">{{ top.score }}%</span>
                    </div>
                }
                @if (worstScoreQuestions.length === 0) {
                    <span>You're doing great!</span>
                }
            </div>
        </div>
    </div>
</div>
